import { render, staticRenderFns } from "./PhoneIndex.vue?vue&type=template&id=eda195bc&scoped=true&"
import script from "./PhoneIndex.vue?vue&type=script&lang=js&"
export * from "./PhoneIndex.vue?vue&type=script&lang=js&"
import style0 from "./PhoneIndex.vue?vue&type=style&index=0&id=eda195bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda195bc",
  null
  
)

export default component.exports